

import { useEffect, useState } from "react";
// hooks
import { useLanding } from "../../../hooks/useLanding";
import { usePersonaNatural } from "../../../hooks/usePersonaNatural";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../components/BannerPanel";
import { MenuUsuario } from "../components/MenuUsuario";
import { Cards } from "../../Landing/components/Cards/cards";
import { Buttonloadmore } from "../../../components/Landing/Buttonloadmore";
import { Footer } from "../../../components/Landing/Footer";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
//  styled components
import { Form, Select, Input, Button, Table, Empty } from "antd";
// select data
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { EntidadOptions, tipoEntidad } from "../../../utils/dataSelectOptions";
import { useNavigate } from "react-router-dom";
import apiMaestras from "../../../api/Maestras/api-maestras";
export const BuscarConvocatoria = () => {
   // states
   const { cargarInformacionParticipante } = usePersonaNatural();
   const {
      principalState,
      setPrincipalState,
      getConvocatorias,
      getSiguientesConvocatorias,
      limipiarfiltros,
      buscarconvocatorias,
      visibleButton,
      loadingConvocatorias
   } = useLanding();
   // fields
   const fields = [
      { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
      { name: "area", value: principalState.buscarconvocatorias.area },
      { name: "entidad", value: principalState.buscarconvocatorias.entidad },
      { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
      { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
      { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
      { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
      { name: "anio", value: principalState.buscarconvocatorias.anio },
   ];

   const coloresEstado = {
    Abierta: "#21BA45",
    "En espera": "#EFC236",
    Cerrada: "#9F0505",
  };

  const navigate = useNavigate();

   useEffect(() => {
      let mounted = true;
      if (mounted) {
         // generarAnios();
         cargarInformacionParticipante();
         getConvocatorias();
      }
      return () => {
         mounted = false;
      };
   }, []);

   const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

   useEffect(() => {
    getLineasConvocatorias();
 }, []);

   const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

   const obtenerCategorias = async (id_linea: number) => {
      //
      try {
         const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
         let infoupdate: any = { ...principalState.buscarconvocatorias };
         infoupdate["linea_convocatoria"] = id_linea;
         return setPrincipalState({ ...principalState, categoria_linea_convocatorias: data, buscarconvocatorias: infoupdate });
      } catch (error) {
         // console.log(object)
      }
   }
   const [mostrarTabla, setMostrarTabla] = useState(false);
   const toggleVista = () => {
      setMostrarTabla(!mostrarTabla);
   };

  const datosTabla = principalState.convocatoriasslice
    .filter((data: any) => data.entidad !== "AGENDA CULTURAL")
    .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
    .map((data: any) => ({
      // Mapear aquí los datos que quieres mostrar en la tabla
      idconvocatorias: data.idconvocatorias,
      nombre_convocatoria: data.nombre_convocatoria,
      fechas: data.fechas,
      estado: data.estado,
      entidad: data.entidad,
      linea_convocatoria: data.linea_convocatoria,
      tipo_participante: data.tipo_participante,
      area: data.area
    }));


    const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
      const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
      if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
        return valueFilter[0].nombre;
      } else {
        if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
          return "Banco de Jurados";
        } else {
          return "BEPS";
        }
      }
    };


   const columns = [
      {
        title: "Nombre convocatoria",
        width: 300,
        dataIndex: "nombre_convocatoria",
        key: "nombre_convocatoria",
        render: (datos) => {
          return (
            <span style={{whiteSpace: "pre-line"}}>
              {datos}
            </span>
          );
        },
      },
      {
        title: "Línea convocatoria",
        width: 450,
        render: (datos) => {
          return (
            <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
              {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
            </span>
          );
        },
      },
      {
        title: "Fecha apertura",
        width: 130,
        render: (datos) => {
          let fecha = datos.fechas;
          if (Array.isArray(datos.fechas)) {
            let fechaapertura = datos.fechas.filter(
              (data) => data.clave === "Apertura"
            );
            if (fechaapertura.length > 0) {
              fecha = fechaapertura[0].valormin.substring(0, 10);
            }
          }
          return <span className="font-family-Montserrat-Regular">{fecha}</span>;
        },
      },
      {
        title: "Fecha cierre",
        width: 100,
        render: (datos) => {
          let fecha = datos.fechas;
          if (Array.isArray(datos.fechas)) {
            let fechacierre = datos.fechas.filter(
              (data) => data.clave === "Cierre"
            );
            if (fechacierre.length > 0) {
              fecha = fechacierre[0].valormin.substring(0, 10);
            }
          }
          return <span className="font-family-Montserrat-Regular">{fecha}</span>;
        },
      },
      {
        title: "Tipo participante",
        width: 150,
        render: (datos) => {
          if (Array.isArray(datos.tipo_participante)) {
            var tipo_participante = ""
            datos.tipo_participante.forEach((tipo) => {
              tipo_participante += tipo.text + " - ";
            });
          }
          return <span className="font-family-Montserrat-Regular" style={{whiteSpace: "pre-line"}}>{tipo_participante}</span>;
        }
      },
      {
        title: "Estado",
        width: 100,
        render: (datos) => {
          let fecha = datos.fechas;
          if (Array.isArray(datos.fechas)) {
            let fechaCierre = datos.fechas.filter(
              (data) => data.clave === "Cierre"
            );

            if (fechaCierre.length > 0) {
              fecha = fechaCierre[0].valormax

              let fechaActual = new Date();
              let anio = fechaActual.getFullYear();
              let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
              let dia = ('0' + fechaActual.getDate()).slice(-2);
              let hora = ('0' + fechaActual.getHours()).slice(-2);
              let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

              let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

              let cierreAct = new Date(fecha);
              cierreAct.setHours(cierreAct.getHours() - 1);
              let anioc = cierreAct.getFullYear();
              let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
              let diac = ('0' + cierreAct.getDate()).slice(-2);
              let horac = ('0' + cierreAct.getHours()).slice(-2);
              let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
              let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

              if (fechaYHoraActualizada <= fechaYHora){
                var estadoAct = 'Cerrada'
              } else {
                estadoAct = datos.estado
              }
            }
          }
          return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                    {estadoAct}
                  </span>)
        },
      },
      {
        title: "Entidad",
        width: 30,
        dataIndex: "entidad",
        key: "entidad",
      },
      {
        title: "Áreas",
        width: 220,
        render: (datos) => {
          if (Array.isArray(datos.area)) {
            let area = "";
            datos.area.forEach((tipo, index) => {
              area += tipo.text;
              if (index < datos.area.length - 1) {
                area += ", ";
              } else {
                area += ".";
              }
            });
            return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
          }
          return null;
        }
      }
    ];

    const handleRowClick = (record: any) => {
      window["scrollTo"]({ top: 0, behavior: "smooth" });
      navigate(`/verconvocatoria/${record.idconvocatorias}`);
    };
   return (
      <div>
         <Header />
         <BannerPanel />
         <div
            className="container-fluid2"
            style={{ paddingTop: "1%", paddingBottom: "5%" }}
         >
            <div className="row">
               <MenuUsuario activeItem={3} />
               <div className="col-12 col-md-12 col-lg-9">
                  <div className="row">
                     <div className="justify-content-center">
                        <div className="container-titles-information-component">
                           <div className="container-title-left-landing font-family-Montserrat-Regular font-size-24px font-color-FF8900">
                              <span className="font-family-Montserrat-Bold">Buscar </span>convocatorias
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="row" style={{ marginTop: "2%" }}>
                     <div className="col-12 font-size-14px font-family-Montserrat-Regular">
                     Usa uno de los filtros para encontrar lo que buscas
                     </div>
                  </div>
                  <Form
                      name="basic"
                      className="bg-light"
                      size="large"
                      layout="vertical"
                      fields={fields}
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '30px',
                        padding: '30px'
                      }}
                      onFieldsChange={async (_: any, fields: any) => {
                        let infoupdate: any = { ...principalState.buscarconvocatorias };
                        infoupdate[_[0].name[0]] = _[0].value;
                        return setPrincipalState({ ...principalState, buscarconvocatorias: infoupdate });
                      }}
                  >
                      <div className="row g-3 gb-0 mt-3 justify-content-center">
                        {/*<div className="col-12 col-md-3 col-lg-3 mb-0 mt-0">
                            <Form.Item label="Nombre convocatoria" name="buscar_palabra_clave">
                              <Input style={{ width: "100%" }} placeholder="Nombre convocatoria" />
                            </Form.Item>
                        </div>*/}
                        <div className="col-12 col-md-5 col-lg-5 mb-0 mt-0">
                          <Form.Item label="Línea convocatoria" name="linea_convocatoria">
                            <Select
                                showSearch
                                optionFilterProp="children"
                                suffixIcon={<FlechaSelect />}
                                size="large"
                                style={{ width: "100%" }}
                                placeholder="Seleccionar..."
                            >
                                {principalState.linea_estrategicas
                                  .slice()
                                  .reverse()
                                  .filter(({ nombre }: any) =>
                                      !nombre.includes ('AGENDA CULTURAL')
                                    )
                                  .map(({ id, nombre }: any) => (
                                    <Select.Option key={id} value={id}>
                                      {nombre}
                                    </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </div>
                        <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                            <Form.Item label="Perfil" name="perfil_participante">
                              <Select allowClear placeholder="Seleccionar...">
                                  {QuienParticipaOptions.map(({ value, text }, i) => (
                                    <Select.Option key={i} value={value}>{text}</Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                        </div>
                        <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                            <Form.Item label="Área" name="area">
                              <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                                  {principalState.area.map(({ nombre }: any, i) => (
                                    <Select.Option key={i} value={nombre}>{nombre}</Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                        </div>
                        <div className="col-6 col-md-2 col-lg-2 mb-0 mt-0">
                            <Button className="button-azul-ghost" style={{ marginTop: '20px' }} onClick={limipiarfiltros}>
                              Limpiar filtros
                            </Button>
                            <Button className="button-azul-radius" onClick={buscarconvocatorias}>
                              Buscar
                            </Button>
                        </div>
                        {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                            <Form.Item label="Categoría" name="categoria_linea_convocatoria">
                              <Select dropdownMatchSelectWidth={false} disabled={principalState.categoria_linea_convocatorias.length < 1} allowClear placeholder="Seleccionar...">
                                  {principalState.categoria_linea_convocatorias.map(({ id, nombre }) => (
                                    <Select.Option key={id} value={id}>{nombre}</Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                        </div>*/}
                        {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                            <Form.Item label="Tipo convocatoria" name="tipo_convocatoria">
                              <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                                  {tipoConvocatoria.map(({ value, text }: any, i) => (
                                    <Select.Option key={i} value={value}>{text}</Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                        </div>
                        */}
                        {/* <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                            <Form.Item label="Año" name="anio">
                              <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                                  {principalState.anios.map((year: any, i) => (
                                    <Select.Option key={i} value={year}>{year}</Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                        </div> */}
                      </div>
                    </Form>
                    <br />
                     <div className="row">
                        <div className="col-12">
                           {/* Botón para cambiar entre tabla y tarjetas */}
                           <Button onClick={toggleVista}>
                           {mostrarTabla ? 'Mostrar en tarjetas' : 'Mostrar en tabla'}
                           </Button>
                        </div>
                     </div>
                     {mostrarTabla ? (
                      <div className="row">
                          <div className="col-12">
                          <Table
                            style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
                            locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
                            pagination={false}
                            columns={columns}
                            dataSource={datosTabla}
                            size="middle"
                            bordered={false}
                            loading={loadingConvocatorias}
                            onRow={(record) => {
                                return {
                                onClick: () => handleRowClick(record),
                                style: {
                                  cursor: 'pointer',
                                },
                                }
                            }}
                          />
                          </div>
                      </div>
                     ) :
                      <div className="row">
                          {principalState.convocatoriasslice
                            .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias) // Ordena por idconvocatorias
                            .filter((data: any) => data.entidad != "AGENDA CULTURAL")
                            .map((data: any, index: number) => (
                              <div key={`contenedor_${index}`} className="col-12 col-md-3">
                                <Cards key={index} convocatorias={data} />
                              </div>
                          ))}
                      </div>
                     }
                  {visibleButton &&
                     <Buttonloadmore doFunction={() => getSiguientesConvocatorias()} />
                  }
               </div>
            </div>
         </div>
         <Footer />
      </div>
   );
};

